/*
 * OptionListSubtitle Messages
 *
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  optionText: {
    id: 'app.productConfig.components.OptionListSubtitle.optionText',
    defaultMessage: 'Elige {quantity}',
  },
  minMaxOptionText: {
    id: 'app.productConfig.components.OptionListSubtitle.minMaxOptionText',
    defaultMessage: 'Elige entre {minQuantity} y {quantity}',
  },
  uncompletedSelection: {
    id: 'app.productConfig.components.OptionListSubtitle.uncompletedSelection',
    defaultMessage: 'Te faltan {quantity}',
  },
  uncompletedSelectionOne: {
    id:
      'app.productConfig.components.OptionListSubtitle.uncompletedSelectionOne',
    defaultMessage: 'Te falta {quantity}',
  },
  completedSelection: {
    id: 'app.productConfig.components.OptionListSubtitle.completedSelection',
    defaultMessage: 'Completaste la selección',
  },
  minMaxCompletedSelection: {
    id:
      'app.productConfig.components.OptionListSubtitle.minMaxCompletedSelection',
    defaultMessage: 'Elegiste {quantity}',
  },
});
